/* eslint-disable react/jsx-props-no-spreading */
import { ComponentType, Route, RouteComponentProps, RouteProps } from "react-router-dom";

interface FeatureFlagRouteProps extends Omit<RouteProps, "render" | "component"> {
  featureFlag: boolean;
  enabledComponent: ComponentType<RouteComponentProps>;
  disabledComponent: ComponentType<RouteComponentProps>;
}

const FeatureFlagRoute = ({
  featureFlag,
  enabledComponent: EnabledComponent,
  disabledComponent: DisabledComponent,
  ...routeProps
}: FeatureFlagRouteProps) => {
  return (
    <Route
      {...routeProps}
      render={(renderProps) =>
        featureFlag ? <EnabledComponent {...renderProps} /> : <DisabledComponent {...renderProps} />
      }
    />
  );
};

export default FeatureFlagRoute;
